import classNames from 'classnames'
import styles from './index.module.scss'

const Divider: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={classNames(styles.divider, className)} />
)

export default Divider
